import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { ReadOnlyInfo } from "./ReadOnlyInfo";
import { formatDateNoDayOfWeek, formatDateNoTime } from "../../../utils/functions";
import PlaceholderUntilLoaded from "../../../components/global_components/PlaceholderUntilLoaded";

import "./PublicApplicationDetails.scss";

interface IPublicApplicationDetails {
  submittedDate: string;
  expirationDate: string;
  confirmationNumber: string;
  isLoading: boolean;
}

export const PublicApplicationDetails = ({
  submittedDate,
  expirationDate,
  confirmationNumber,
  isLoading,
}: IPublicApplicationDetails) => {
  return (
    <Segment padded attached='top'>
      <Header as='h2' className='tw-mb-0'>
        Application
      </Header>
      <PlaceholderUntilLoaded isLoading={isLoading} lineCount={2}>
        <div className='submission-details'>
          <ReadOnlyInfo label='Application Number' data={confirmationNumber} />
          <ReadOnlyInfo label='Submitted' data={formatDateNoDayOfWeek(submittedDate)} />
          {expirationDate ? <ReadOnlyInfo label='Expires' data={formatDateNoTime(expirationDate)} /> : <div />}
        </div>
      </PlaceholderUntilLoaded>
    </Segment>
  );
};

export default PublicApplicationDetails;
